import { ParentComponent, mergeProps } from 'solid-js';
import { useTheme } from '../ThemeProvider';

interface Props {
  direction?: 'vertical' | 'horizontal' | 'diagonal' | number;
  startColor?: string;
  endColor?: string;
}

export const GradientText: ParentComponent<Props> = passedProps => {
  const [theme] = useTheme();
  const { colors } = theme();

  const props = mergeProps(
    {
      direction: 'diagonal',
      startColor: colors.primary,
      endColor: colors.secondary,
    },
    passedProps,
  );

  let gradient = '';
  if (typeof props.direction === 'number') {
    gradient = `linear-gradient(${props.direction}deg, ${props.startColor}, ${props.endColor})`;
  } else {
    switch (props.direction) {
      case 'diagonal':
        gradient = `linear-gradient(135deg, ${props.startColor}, ${props.endColor})`;
        break;
      case 'horizontal':
        gradient = `linear-gradient(90deg, ${props.startColor}, ${props.endColor})`;
        break;
      default:
        gradient = `linear-gradient(${props.startColor}, ${props.endColor})`;
    }
  }

  // background-image rather than the background shorthand - since solid 1.9 the static
  // properties here are baked into the element's template and the dynamic gradient is set
  // afterwards, and the shorthand would reset background-clip back to border-box, painting the
  // gradient as a solid box behind the text instead of through it.
  return (
    <span
      style={{
        'background-image': gradient,
        '-webkit-background-clip': 'text',
        'background-clip': 'text',
        '-webkit-text-fill-color': 'transparent',
      }}
    >
      {props.children}
    </span>
  );
};
